import { EditIcon, HintCard, Inline, ObjectIcon, PlacementIcon, styled } from 'canoe';
import React from 'react';
import { s3Image } from 'site-constants';
import { H1, P, Section } from 'styleguide';

import { useCurrentSnapshot, useToolboxTab } from 'craft/state';

const InlineIcon = styled.div`
  padding-top: 4px;
  margin-bottom: -4px;
`;

export const Placeholder = () => {
  const { snapshot, placement } = useCurrentSnapshot();
  const { forcePlacementsTab } = useToolboxTab();

  if (!snapshot) {
    return (
      <div data-cy="editor-empty-state-placeholder" css={{ backgroundColor: 'white' }}>
        <Section />
        <Section align="center" size="lg">
          <img src={s3Image('/svg/tutorial-empty-state.svg')} alt="Empty state placeholder" />
          <Section>
            <H1 css={{ lineHeight: '.8em' }}>Drag &amp; Drop</H1>
            <P subtle>Drag &amp; drop components from the Palette on the left into this area</P>
          </Section>
        </Section>
      </div>
    );
  }

  if (forcePlacementsTab) {
    return (
      <div data-cy="editor-empty-state-placeholder">
        <HintCard
          marginTop="xxl"
          marginBottom="xxl"
          orderedList
          tips={[
            <Inline space="xxs">
              Finish placing content
              <InlineIcon>
                <PlacementIcon size="s" color="BerryBlueD10" />
              </InlineIcon>{' '}
              using the panel on the right.
            </Inline>,
            `Click ${placement?.id ? "'Update'" : "'Start Editing Content'"}.`,
            'You can change Content width & height after.',
          ]}
        />
      </div>
    );
  }

  return (
    <div data-cy="editor-empty-state-placeholder">
      <HintCard
        marginTop="xxl"
        marginBottom="xxl"
        orderedList
        variant="primary"
        tips={[
          <Inline space="xxs">
            Drag Components{' '}
            <InlineIcon>
              <ObjectIcon size="s" color="BrandPurpleD10" />
            </InlineIcon>{' '}
            in from the toolbox on the left.
          </Inline>,
          <Inline space="xxs">
            Customise Components using the panel on the right{' '}
            <InlineIcon>
              <EditIcon size="s" color="BrandPurpleD10" />
            </InlineIcon>
          </Inline>,
        ]}
      />
    </div>
  );
};
